// extracted by mini-css-extract-plugin
export default {"wingContainer":"WingSettings_wingContainer__srr-j","wingWrapper":"WingSettings_wingWrapper__vZvpM"};